import { use } from 'react'
import { OTPForm } from '../OTPForm'
import { LoginContext } from '../../contexts/Login'
import { RECOVERY_OTP } from 'mfa'

export const RecoveryOTP = (props) => (
  <OTPForm
    {...props}
    icon='vpn_key'
    iconColor='orange600'
    titleKey='recoveryCode'
    labelKey='recoveryCode.title'
    mfaType={RECOVERY_OTP}
    fieldName='otp'
    fieldId='recovery-code'
  />
)

const RecoveryOTPWithContext = (props) => {
  const ctx = use(LoginContext)
  return <RecoveryOTP ctx={ctx} {...props} />
}
RecoveryOTPWithContext.displayName = 'RecoveryOTP'

export default RecoveryOTPWithContext
